import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import { RouterProvider } from "react-router-dom";
import router from "./routes/routerConfig";
import { Amplify } from "aws-amplify";
import config from "../src/configs/amplifyconfiguration_new.json";
import prodConfig from "../src/configs/prod-amplify.json";
import { Provider } from "react-redux";
import store from "./state/store";
import { isProd } from "./utlis/helpers";
import { I18nProvider } from "./i18n/I18nProvider";
import { hydrateActiveRegion } from "./configs/activeRegion";

const uploadFile = isProd ? prodConfig : config;
Amplify.configure(uploadFile);
// Restore the account region before routing, session locale clamping, or any
// Add/Edit/Import unit resolver runs. The users API refreshes this cached value
// after authentication through fetchLoggedUserInfo().
hydrateActiveRegion();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <I18nProvider>
      <RouterProvider router={router} />
    </I18nProvider>
  </Provider>,
);
